export const APP_LANGUAGES = ['fa', 'en'] as const;

export type AppLang = (typeof APP_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: AppLang = 'fa';

export const STORAGE_KEY = 'app.lang';

export const ACCEPT_LANGUAGE_MAP: Record<AppLang, string> = {
  fa: 'fa',
  en: 'en',
};

export const HTML_LANG_MAP: Record<AppLang, string> = {
  fa: 'fa',
  en: 'en',
};

export const TEXT_DIRECTION_MAP: Record<AppLang, 'rtl' | 'ltr'> = {
  fa: 'rtl',
  en: 'ltr',
};
